import {
    FC,
    ExtendProps,
    SignalPropsHandler
} from '@gongxigames/framework/core/fragments/BuilderY';
import {Graphics as PixiGraphics, Container as PixiContainer, BLEND_MODES, Shader } from 'pixi.js';
import {$Container, ExtendContainerProps} from './Container';

type BaseGraphicsProps = {
    nextRoundedRectBehavior?: boolean;
    blendMode?: BLEND_MODES;
    cacheAsBitmap?: boolean;
    pluginName?: string;
    shader?: Shader;
    tint?: number;
};

export type GraphicsProps = ExtendContainerProps<BaseGraphicsProps, PixiGraphics>;

const GRAPHICS_PROPS_LIST = ['nextRoundedRectBehavior','blendMode','cacheAsBitmap','pluginName','shader','tint'] as const;
const graphicsPropsHandler = new SignalPropsHandler<GraphicsProps, PixiGraphics>()
    .propsToHandle(GRAPHICS_PROPS_LIST);

/**
 * Basic pixi Graphics component.
 * Use `ref` callback to draw some graphic primitives
 * ```ts
 * <Graphics ref={ g => {
 *  g
 *    .beginFill()
 *    .drowBox()
 *    .endFill();
 * }}/>
 * ```
 */
export const $Graphics: FC<GraphicsProps> = (props) => {
    const instance = props.instance ??= new PixiGraphics();

    const unsubscribeProps = graphicsPropsHandler.apply(props, instance);

    instance.on('destroyed', unsubscribeProps);

    return $Container(props as PixiContainer<PixiGraphics>);
};

// Helper types
export type ExtendGraphicsPropsSimple<T> = T & GraphicsProps;
export type ExtendGraphicsProps<T> = ExtendProps<T, GraphicsProps, PixiGraphics>;

